<template>
  <div class="live_apply_box">
    <div class="title_top_hr">
      <p>
        <i></i>
        <span>发布培训</span>
        <el-divider></el-divider>
      </p>
    </div>
    <el-form class="" method="POST" :model="apply" :rules="rules" label-position="left" label-width="70px" :hide-required-asterisk=true ref="registerForm" @submit.prevent="submitForm" :status-icon=true >
      <el-form-item label="标题" prop="title">
          <el-input type="text" v-model="apply.title"></el-input>
      </el-form-item>
      <el-form-item label="简介" prop="content">
          <el-input type="textarea" v-model="apply.content"></el-input>
      </el-form-item>
      <el-form-item label="培训类型" prop="type">
        <el-select v-model="apply.type" placeholder="请选择">
          <el-option
            v-for="item in typeList"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="培训内容" prop="file">
        <upload-view v-if="apply.type === 1 || apply.type === 2" :filestype="videoType" :imgurl="apply.video"  @files = "filesUrl"></upload-view>
        <editor-view
        v-if="apply.type === 3"
        :value='apply.text'
        @monitor = "monitor">
        </editor-view>
      </el-form-item>
      <el-form-item label-width="150px" label="是否添加到已有系列" prop="is_add">
        <el-switch
          v-model="apply.is_add"
          active-color="#d7b76d">
        </el-switch>
      </el-form-item>
      <el-form-item v-show="apply.is_add" label="选择培训系列" prop="sel_chapter">
        <el-select v-model="apply.sel_chapter" filterable placeholder="请选择">
          <el-option
            v-for="item in chapterList"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <a @click = "addSeriesOnnOff = !addSeriesOnnOff">点击新建培训系列</a>
      </el-form-item>
      <div v-show="addSeriesOnnOff" class="add_series">
        <el-form-item label="系列标题" prop="series_title">
          <el-input v-model="apply.series_title" placeholder="请输入内容"></el-input>
        </el-form-item>
        <el-form-item label="系列简介" prop="series_content">
          <el-input v-model="apply.series_content" placeholder="请输入内容"></el-input>
        </el-form-item>
        <el-form-item label="系列封面" prop="file">
          <upload-view :filestype="imgType" :imgurl="apply.video"  @files = "filesUrl"></upload-view>
        </el-form-item>
      </div>
      <el-form-item label="添加标签" prop="tag_id">
        <el-select
            v-model="apply.tag_id"
            multiple
            filterable
            default-first-option
            :multiple-limit = 5
            placeholder="请选择文章标签">
            <el-option
              v-for="item in labelOptions"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
      </el-form-item>
      <el-form-item>
        <div class="rg_form_box_form_item">
          <el-button type="primary" class="rg_form_box_form_sub" @click="submitForm('registerForm')">提交</el-button>
        </div>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import upload from '../Public/fileUpload.vue'
import editor from '../Public/wangeditor.vue'
export default {
  components: {
    uploadView: upload,
    editorView: editor
  },
  data () {
    return {
      labelOptions: [], // 标签列表
      optionList: [ // 板块列表
        {
          label: '联盟生态',
          options: [{
            value: 5,
            label: '培训',
            type: 'live'
          }]
        }
      ],
      typeList: [{
        value: 1,
        label: '视频'
      }, {
        value: 2,
        label: '音频'
      }, {
        value: 3,
        label: '图文'
      }],
      apply: {
        title: '',
        content: '',
        nav_id: '',
        tag_id: '',
        type: '',
        text: '',
        video: '',
        is_add: false,
        sel_chapter: ''
      },
      addSeriesOnnOff: false,
      imgType: 'liveBackground',
      videoType: 'video',
      chapterList: [{
        value: '1',
        label: '章节1'
      }, {
        value: '2',
        label: '章节2'
      }, {
        value: '3',
        label: '章节3'
      }], // 章节列表
      rules: {
        room_name: [{ required: true, message: '请输入直播标题', trigger: 'blur' }],
        room_content: [{ required: true, message: '请输入直播简介', trigger: 'blur' }],
        ymd: [{ required: true, message: '请选择直播日期', trigger: 'blur' }],
        start_time: [{ required: true, message: '请选择直播时间', trigger: 'blur' }],
        room_duration: [{ required: true, message: '请选择直播时长', trigger: 'blur' }],
        nav_id: [{ required: true, message: '请选择直播时长', trigger: 'blur' }]
      }
    }
  },
  created () {
    const vueThat = this
    vueThat.myApi.getLabel().then(function (res) {
      if (res.data.code === 200) {
        vueThat.labelOptions = res.data.data
      }
    })
  },
  methods: {
    // 获取视频文件
    filesUrl: function (data, type) {
      this.apply.video = data
    },
    // 实时监控更新正文内容
    monitor: function (val) {
      this.apply.text = val
    },
    // 提交
    submitForm (formName) {
      const vueThat = this
      vueThat.$refs[formName].validate(async (valid) => {
        vueThat.apply.start_ymd = vueThat.apply.ymd.split('-').join('')
        vueThat.apply.start_time = vueThat.apply.start_time / 1000
        if (valid) {
          try {
            await vueThat.$store.dispatch('apply/liveSub', vueThat.apply)
              .then(function (res) {
                if (res.data.code === 200) {
                  vueThat.$alert('提交申请成功，请耐心等待审核通过', '温馨提示', {
                    type: 'success',
                    iconClass: 'iconfont icon-icon_richeng_btn_pass',
                    confirmButtonText: '确定',
                    showClose: false,
                    callback: action => {
                      vueThat.$store.commit('editPersonalMeunAct', 'liveList')
                      vueThat.$router.push({ name: 'liveList' })
                    }
                  })
                }
              })
          } catch (e) {}
        } else {
          return false
        }
      })
    }
  }
}
</script>

<style scoped="scoped">
</style>
